import React from 'react';
import { Spinner } from 'reactstrap';

import './Loader.css';

/**
 * Adds a React component to show a loading icon.
 *
 *  - Roles
 *     - Show a loading icon.
 *     - Cover up the complete screen so no action can be performed while the loading animation is active.
 *
 * @param isLoading if true, a loading animation is seen on the screen.
 */

const Loader = (props) =>
    props.isLoading ? (
        <div
            role="alert"
            aria-busy="true"
            className="loader-container"
            data-testid="loader-container"
        >
            <Spinner color="primary" className="spinner"></Spinner>
            <span className="loader-text" data-testid="loader-text">
                Loading
            </span>
            <style>
                {`
          @keyframes spin {
            0% {
              transform: rotate(0deg);
            }
            100% {
              transform: rotate(360deg);
            }
          }
        `}
            </style>
        </div>
    ) : (
        <div />
    );

export default Loader;
